var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"id":"activity-feed"}},[_c('h6',{staticClass:"left-align"},[_vm._v("Activity Feed")]),_vm._l((_vm.evts),function(evt){return _c('article',{key:evt.id},[(evt.event_type === 'rating-transaction')?_c('event-rating-transaction',{attrs:{"evt":evt}}):_vm._e()],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }